(function () {
  'use strict';
  document.querySelectorAll('[data-psearch]').forEach(function (root) {
    var input = root.querySelector('input[name="q"]');
    var panel = root.querySelector('[data-ps-panel]');
    if (!input || !panel) return;
    var def = panel.querySelector('[data-ps-default]');
    var res = panel.querySelector('[data-ps-results]');
    var url = root.getAttribute('data-url') || '/search/suggest';
    var timer = null, ctrl = null, active = -1, lastQ = '';

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      root.classList.add('is-open');
    }
    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      root.classList.remove('is-open');
      setActive(-1);
    }
    function showDefault() {
      res.hidden = true;
      def.hidden = false;
      setActive(-1);
      if (def.textContent.trim()) open(); else close();
    }
    function links() {
      var scope = res.hidden ? def : res;
      return Array.prototype.slice.call(scope.querySelectorAll('.ps__link'));
    }
    function setActive(i) {
      var list = links();
      list.forEach(function (a, k) { a.classList.toggle('is-active', k === i); });
      active = i;
      if (i >= 0 && list[i]) list[i].scrollIntoView({ block: 'nearest' });
    }
    function search(q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var qs = '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,query' +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';
      res.classList.add('is-loading');
      fetch(url + qs, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (q !== lastQ) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.getElementById('predictive-search-results');
          res.innerHTML = el ? el.innerHTML : '';
          res.hidden = false;
          def.hidden = true;
          setActive(-1);
          open();
        })
        .catch(function () {})
        .then(function () { res.classList.remove('is-loading'); });
    }

    input.addEventListener('focus', function () {
      if (input.value.trim().length < 2) showDefault(); else open();
    });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      lastQ = q;
      if (q.length < 2) { showDefault(); return; }
      timer = setTimeout(function () { search(q); }, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      var list = links();
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(active + 1, list.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
      else if (e.key === 'Enter' && active >= 0 && list[active]) { e.preventDefault(); window.location.href = list[active].href; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });
    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !root.contains(e.relatedTarget)) close();
    });
  });
})();
